var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid d-flex flex-wrap justify-content-between"},[_c('div',[_c('div',{staticClass:"copyright"},[_vm._v("\n        RIXIT © "+_vm._s(_vm.year)+"\n      ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }